module.exports = __webpack_public_path__ + "img/map.d688fe47.jpg";